import { ClassManipulatorComponent } from './class-manipulator.component';

export class ClassTogglerComponent extends ClassManipulatorComponent {
    protected get isAddOnly(): boolean {
        return this.element.dataset.toggleAdd === 'true';
    }

    get className(): string {
        return this.element.dataset.className;
    }

    constructor(protected element: HTMLElement) {
        super(element);
    }

    public manipulateClasses(): void {
        for (const target of this.targets) {
            if (this.isAddOnly) {
                target.classList.add(this.className);

                continue;
            }

            target.classList.toggle(this.className);
        }
    }
}
